var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClinicUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.916C0 36.5152 0.48483 37 1.08398 37H31.4355C32.0347 37 32.5195 36.5152 32.5195 35.916C32.5195 28.146 26.1977 21.6797 18.4277 21.6797H14.0918C6.3218 21.6797 0 28.146 0 35.916Z",
    fill: "#45C1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4277 21.6797H16.2598V37H31.4355C32.0347 37 32.5195 36.5152 32.5195 35.916C32.5195 28.146 26.1977 21.6797 18.4277 21.6797Z",
    fill: "#44A4EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 37C25.2286 37 21.8242 33.5956 21.8242 29.4121C21.8242 27.8158 22.3302 26.2702 23.2872 24.9428C24.7396 22.9844 27.026 21.8242 29.4121 21.8242C33.5956 21.8242 37 25.2286 37 29.4121C37 33.5956 33.5956 37 29.4121 37Z",
    fill: "#F23051"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 29.4121C37 25.2286 33.5956 21.8242 29.4121 21.8242V37C33.5956 37 37 33.5956 37 29.4121Z",
    fill: "#D92C48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5801 28.3281H30.4961V27.2441C30.4961 26.645 30.0113 26.1602 29.4121 26.1602C28.813 26.1602 28.3281 26.645 28.3281 27.2441V28.3281H27.2441C26.645 28.3281 26.1602 28.813 26.1602 29.4121C26.1602 30.0113 26.645 30.4961 27.2441 30.4961H28.3281V31.5801C28.3281 32.1792 28.813 32.6641 29.4121 32.6641C30.0113 32.6641 30.4961 32.1792 30.4961 31.5801V30.4961H31.5801C32.1792 30.4961 32.6641 30.0113 32.6641 29.4121C32.6641 28.813 32.1792 28.3281 31.5801 28.3281Z",
    fill: "#E6EEFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4961 31.5801V30.4961H31.5801C32.1792 30.4961 32.6641 30.0113 32.6641 29.4121C32.6641 28.813 32.1792 28.3281 31.5801 28.3281H30.4961V27.2441C30.4961 26.645 30.0113 26.1602 29.4121 26.1602V32.6641C30.0113 32.6641 30.4961 32.1792 30.4961 31.5801Z",
    fill: "#DAE2F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50391 9.75586C6.50391 15.1355 10.8801 19.5117 16.2598 19.5117C21.6394 19.5117 26.0156 15.1355 26.0156 9.75586C26.0156 4.37619 21.6394 0 16.2598 0C10.8801 0 6.50391 4.37619 6.50391 9.75586Z",
    fill: "#45C1F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0156 9.75586C26.0156 4.37619 21.6394 0 16.2598 0V19.5117C21.6394 19.5117 26.0156 15.1355 26.0156 9.75586Z",
    fill: "#44A4EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicUsers);
export default __webpack_public_path__ + "static/media/clinic-users.0f3df301255bb304966d56310e6445e3.svg";
export { ForwardRef as ReactComponent };